// LIBRARY
import React, { useState, useEffect } from 'react';
import { Row, Col, Form, Tabs, Table, Badge, Checkbox, Typography } from 'antd';
import PropTypes from 'prop-types';

// CUSTOM MODULES
import Actions from './actions';
import { find, filter, orderBy, merge } from 'lodash';
import { fetchIresult, postTempIresult } from 'services/lab_result/result';
import moment from 'moment';

const { Link } = Typography;

function Iresults({getSelectedResults, closeDrawer, sampleSpecimenID, isApproved, initialValues}){
const [selectedRows, setSelectedRows] = useState([]);
const [tabData, setTabData] = useState([]);
const [activeTab, setActiveTab] = useState('');
const [formRef] = Form.useForm();

let machineStgData = [];

useEffect(()=>{

	const fetchData = async () =>{
		const data = await fetchIresult(sampleSpecimenID);

		let machineRunDates =[];
		let initVals = [];



		if(Object.entries(initialValues).length > 0){
			for(const [key, value] of Object.entries(initialValues)){
				initVals.push({
					fieldName: Number(key),
					fieldResult: value,
				});
			}
		}


		if(data.length > 0){
			const tabData = data.map((machineRecord, machineIndex)=>{
				let tableDataSource = [];
				const {instrumentName, resultCount ,contents} = machineRecord;
				const badgeLength = resultCount; //for now

				let tableData = contents.map((runDate)=>{
					let childrenDataSource = [];
					const { instrumentResultDate } = runDate;
					const machineKey =  Date.parse(instrumentResultDate);

					machineRunDates.push({
						parentKey: machineKey,
						runDate: instrumentResultDate,
						instrumentName: instrumentName,
					});

					runDate.contents.map((content, contentIndex)=>{

						const childKey = Number(machineKey.toString().concat(contentIndex+1));

						tableDataSource.push({
							...content,
							key: childKey,
							instrumentName: instrumentName,
							parentKey: Date.parse(runDate.instrumentResultDate),
							fieldName: `${content.sampleSpecimenID}-${content.examItemID}`,
							instrumentResultDate: instrumentResultDate,
						});
						
						childrenDataSource.push({
							...content,
							key: childKey,
							instrumentName: instrumentName,
							parentKey: Date.parse(runDate.instrumentResultDate),
							fieldName: `${content.sampleSpecimenID}-${content.examItemID}`,
							instrumentResultDate: instrumentResultDate,
						});


						const test = initVals.find( val => val.fieldName === Number(machineKey.toString().concat(contentIndex+1)) );

						if(test !== undefined){
							setSelectedRows( current => [...current, 
								{...content,
									instrumentName,
									instrumentResultDate,
									fieldName: `${content.sampleSpecimenID}-${content.examItemID}`,
									key: childKey,
								}] );
						}
					});

					return ({
						...runDate,
						children: childrenDataSource,
						key: Date.parse(runDate.instrumentResultDate),
					});
				});


				tableData.map((record)=>{
					machineStgData.push(record);
				});

				const tabContent = <Table 
						dataSource={tableDataSource} 
						columns={columnHeader} 
						pagination={false}
						rowSelection={rowSelection}
						rowKey={(record)=>{return record.key}}
					/>;

				return {
					key: instrumentName,
					label: <>{instrumentName} <Badge count={badgeLength} /></>,
					children: tabContent,
				};
			});

			setTabData(tabData);
		}

		setActiveTab(orderBy(machineRunDates,'runDate', 'desc' )[0].instrumentName);
		
	}

	fetchData();

}, []);

	const getDuplicates = (record) =>{
		let targets = {};

		machineStgData.map((stgRec)=>{
			const { children } = stgRec;
			const data = filter(children, { examItemID: record.examItemID });
			 
			 if(data.length > 0){
				if(record.key !== data[0].key){
					targets[data[0].key] = false;
				}
			 }
		});
		return targets;
	}

	const getResultsByKey = (key) =>{
		let target = {};
		machineStgData.map((stgRec)=>{
			const { children } = stgRec;
			const data = children.find( child => { return child.key === Number(key) });
			
			if(![undefined, null, 'undefined', 'null'].includes(data)){
				target = data;
			}
		});

		return target;

	}
	
	const getDuplicatesByReqCode = (fields) =>{
		let targets = {};

		for( const[key, value] of Object.entries(fields)){
			const result = getResultsByKey(key);
			// console.log('result =>', result);

			if(![undefined, null, {}].includes(result)){
				const dupe = getDuplicates(result);
				// console.log('dupe =>', dupe);
				targets = merge(targets, dupe);
			}
		}

		return targets;
	}

	const rowSelection = {
		hideSelectAll: true,		
		renderCell(checked, record, index, originalNode){

			const handleCheckboxChange = (switchValue) =>{
				setSelectedRows(oldArray => [...oldArray, record]);
				const targets = getDuplicates(record);
				formRef.setFieldsValue(targets);
			}

			let checkboxProps = {
				onChange: handleCheckboxChange,
			}

				checkboxProps.disabled = (record.examItemName === null) ? true : false;
				checkboxProps.defaultChecked =(record.examItemName !== null && record.instrumentResultUsed === 'TRUE'); 
			
			if(!isApproved)
			return(
				<Form.Item 
				valuePropName='checked' 
				name={record.key} noStyle>
					<Checkbox {...checkboxProps} />
				</Form.Item>
				);
		},
	};

	const columnHeader = [
		{ 
			title: 'RUN DATE', 
			dataIndex: 'instrumentResultDate', 
			key: 'insstrumentResultDate', 
			width: '20%',
			onCell: (record, index, x)=>{
				const contents = filter(machineStgData, {key: record.parentKey});
				const contentLength = contents[0].contents.length;
				const rowSpan = ((index % contentLength) === 0) ? contentLength : 0;
				let finalTargets = {};

				return{
					rowSpan,
					onClick: (event)=>{ 
						const { targets } = getTargetFields(record.parentKey);
						finalTargets = targets;

						for(const[key, value] of Object.entries(formRef.getFieldsValue())){
							if(!(key in targets)){
								finalTargets[key]= false;
							}
						}

						formRef.setFieldsValue(finalTargets);
					}
				}
			},
		},
		Table.SELECTION_COLUMN,
		// { title: 'KEY', dataIndex: 'key', key: 'key', width: 160 },		// uncomment for debugging purposes.
		{ title: 'EXAM NAME', dataIndex: 'examItemName', key: 'examItemName',  width: 160 },
		{ 
			title: 'EXAM REQUEST CODE', 
			dataIndex: 'examRequestAnalyzerCode', 
			key: 'examRequestAnalyzerCode', 
			width: 160,
			render: (text, record, index)=>{

				const handleRequestCodeClick = () =>{
					const res = getAllResultsByRequestCode(record);
					const resByCode = getDuplicatesByReqCode(res);
					let targets = merge(res, resByCode);

					for(const[key, value] of Object.entries(formRef.getFieldsValue())){
						if(value && !(key in targets)){
							targets[key] = false;
						}
					}

					formRef.setFieldsValue(targets);
				};

				return (![undefined, 'undefined', null, 'null'].includes(record.examItemName)) ? <Link target='_blank' onClick={handleRequestCodeClick}>{text}</Link> : <></>;
			}, 
		},
		{ title: 'EXAM RESULT CODE', dataIndex: 'examItemAnalyzerCode', key: 'examItemAnalyzerCode', width: 160 },		
		{ title: 'RESULTS', dataIndex: 'instrumentResult', key: 'instrumentResult',  width: 60 },
	];
	

	const getAllResultsByRequestCode = (record) =>{
		const data = find(machineStgData, {key: record.parentKey});		
		let targets = {};
		let selectedRowsStg = [];

		if(![undefined, 'undefined', null, 'null'].includes(data)){

			//selection
			const stg = filter(data.children, {examRequestAnalyzerCode: record.examRequestAnalyzerCode});
			(stg.filter( r => ![undefined, null, 'undefined', 'null'].includes(r.examItemName) )).map( res => {
				targets[res.key] = true;
				selectedRowsStg.push(res);
			});

			setSelectedRows(selectedRowsStg);
			
		}

		return targets;
	}


	const getTargetFields = (parentKey, record) =>{
		const data = filter(machineStgData, {key: parentKey});
		let targets = {};
		let dupes = {};

		if(data){
			data.map((rec)=>{
				const { children } = rec;
				
				children.map((child)=>{
					if(child.examItemName !== null && parentKey === child.parentKey){
						setSelectedRows(currentArray => [...currentArray, child]);
						
						merge(dupes, getDuplicates(child));
						targets[child.key] = true;
					}
				})
			});
		}

		return { targetFields: targets, duplicateFields: dupes , targets: merge(targets, dupes)};
	}

	const changeActiveTab = (x) =>{
		setActiveTab(x);
	}

	const handleFormFinish = async () =>{
		const targetFields =  formRef.getFieldsValue();
		let mappedTargetFields = [];
		let tempPayload = [];

		if(!isApproved){			
			for(const [key, value] of Object.entries(targetFields)){
				if([true].includes(value)){
					const target = selectedRows.find(row=>{
						return row.key === Number(key)
					});

					const { fieldName, instrumentResult, instrumentResultDate, examRequestAnalyzerCode, examItemAnalyzerCode, sampleSpecimenID, instrumentName, examItemID, examItemName } = target;

					mappedTargetFields.push({
						fieldName,
						sampleSpecimenID,
						examItemID,
						examItemName,
						iresults_value: target.instrumentResult,
					});

					tempPayload.push( {
						instrumentName,
						sampleSpecimenID,
						examRequestAnalyzerCode,
						examItemAnalyzerCode,
						instrumentResult,
						instrumentResultDate: moment(new Date(instrumentResultDate)).format('YYYY/MM/DD HH:mm:ss'), 
					});
				}

			}
			
			//set selectedResults for API call
			await postTempIresult(tempPayload);

			//send targeted result to the form
			getSelectedResults(mappedTargetFields);
		}

		closeDrawer();

	}

	return(
			<Row>
				<Col span={24}>
					<Form 
						form={formRef} 
						onFinish={handleFormFinish}
						initialValues={
							initialValues
						}
						>	
						<Tabs 
							items={tabData} 
							activeKey={activeTab} 
							onChange={changeActiveTab}
							/>
						<Actions 
							closeDrawer={closeDrawer}/>
					</Form>
				</Col>
			</Row>
		);
}

Iresults.propTypes = {
	getSelectedResults : PropTypes.func,
	closeDrawer : PropTypes.func.isRequired,
	sampleSpecimenID: PropTypes.string.isRequired,
	isApproved: PropTypes.bool.isRequired,
	initialValues : PropTypes.object,
}

export default Iresults;